import styled from '@emotion/styled';

import { ModalBodyProps } from '.';

export const Wrapper = styled.div<Required<ModalBodyProps>>`
  padding: ${({ padding }) => `${padding}px`};
`;
